<template>
  <header id="page-topbar" style="border-top: 1px solid #0e2b8f">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box pl-0">
          <router-link tag="a" to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-small.png" alt height="" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/logo_dinflow.png" alt height="" />
            </span>
          </router-link>
          <button id="vertical-menu-btn" class="btn btn-sm font-size-16 header-item d-block d-lg-none"
            @click="toggleMenu">
            <i class="fa fa-fw fa-bars"></i>
          </button>
          <router-link tag="a" to="/" class="logo logo-light pl-3">
            <span class="logo-lg">
              <img src="@/assets/logo_dinflow.png" alt width="140"/>
            </span>
          </router-link>
        </div>

        <!-- File Manager Navbar Component-->
        <navbar v-if="$route.name === 'FileManager'" />
        <!-- Big Menu dropdown -->
      </div>

      <div class="d-flex">
        <b-dropdown right menu-class="dropdown-menu-lg p-0" toggle-class="header-item noti-icon" variant="black">
          <template v-slot:button-content>
            <i class="bx bx-bell bx-tada" v-if="notifications.length > 0"></i>
            <i class="bx bx-bell" v-else></i>
            <span class="badge badge-danger badge-pill" v-if="notifications.length > 0">
              {{ notifications.length }}
            </span>
          </template>

          <div class="p-3">
            <div class="row align-items-center">
              <div class="col">
                <h6 class="m-0 text-center">
                  {{ $t("navbar.dropdown.notification.text") }}
                </h6>
              </div>
            </div>
          </div>
          <simplebar style="max-height: 230px">
            <a class="text-reset notification-item">
              <div class="text-center mb-3" v-if="notifications.length == 0">
                <i class="bx bxs-file mb-3" style="font-size: 72px;color: #e8ecf1;"></i>
                <p>{{ $t("navbar.dropdown.notification.empty") }}</p>
              </div>
              <div class="media" v-else v-for="(notification, index) in notifications.reverse()" :key="index"
                style="cursor: pointer">
                <img v-if="notification.picture_small != null" :src="loadImage(notification.picture_small)"
                  style="border-radius: 50%" class="avatar-xs mr-3" width="30" />
                <div class="avatar-xs mr-3" v-else>
                  <span class="avatar-title bg-primary rounded-circle font-size-16">
                    <i class="bx bx-bell"></i>
                  </span>
                </div>
                <div class="media-body">
                  <a tag="span" @click="redirect(notification.id)">
                    <div class="font-size-12 text-muted">
                      <h6 class="mt-0 mb-1">
                        {{ notification.title.slice(0, 20) }}...
                      </h6>
                      <p class="mb-1">
                        {{ notification.content.slice(0, 29) }}...
                      </p>
                      <p class="mb-0">
                        <i class="mdi mdi-clock-outline"></i>
                        {{ $d(new Date(notification.created_at), 'short') }}
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </a>
          </simplebar>
          <div class="p-2 border-top">
            <router-link class="btn btn-sm btn-info btn-block text-center" tag="span" :to="{ name: 'notifications' }">
              <i class="mdi mdi-arrow-down-circle mr-1"></i>
              {{ $t("navbar.dropdown.notification.button") }}
            </router-link>
          </div>
        </b-dropdown>
        <!-- fullscreen -->
        <b-dropdown variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            <!-- {{text}} -->
          </template>
          <b-dropdown-item class="notify-item" v-for="(entry, i) in languages" :key="`Lang${i}`" :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)" :class="{ active: lan === entry.language }">
            <img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <!-- <img v-if="picture !== null" class="rounded-circle header-profile-user" :src="image" /> -->
            <img src="@/assets/images/users/default.svg" style="border-radius: 10px"
              class="rounded-circle header-profile-user" alt="" />
            <!-- <span class="d-none d-xl-inline-block ml-1">
              {{ name }}
            </span> -->
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <b-dropdown-item>
            <router-link tag="span" :to="{ path: `/user/profile` }">
              <i class="bx bx-user font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.henry.list.profile") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item>
            <router-link tag="span" to="/user/reset-password">
              <i class="bx bx-reset font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.henry.list.mywallet") }}
            </router-link>
          </b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item>
            <a tag="span" @click.prevent="logout()">
              <i class="bx bx-power-off font-size-16 align-middle mr-1"></i>
              {{ $t("navbar.dropdown.henry.list.logout") }}
            </a>
          </b-dropdown-item>
        </b-dropdown>

        <!-- <div class="dropdown d-inline-block">
          <button type="button" class="btn header-item noti-icon right-bar-toggle toggle-right"
            @click="toggleRightSidebar">
            <i class="bx bx-cog toggle-right"></i>
          </button>
        </div> -->
      </div>
    </div>
  </header>
</template>

<script>
import i18n from "../i18n";
import { mapActions, mapState } from "vuex";
import Navbar from "./blocks/Navbar";
import simplebar from "simplebar-vue";
// import userApi from "../api/userApi";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "Français",
        },
      ],
      lan: localStorage.getItem('dinflow-lang'),
      text: null,
      image: null,
      flag: null,
      value: null,
    };
  },
  components: {
    Navbar,
    simplebar,
  },
  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    // var vm = this;
    // var channel = this.$pusher.subscribe("synchronized");
    // channel.bind("NotificationEvent", function () {
    //   vm.userNotifications();
    // });
  },
  computed: {
    ...mapState({
      notifications: (state) =>
        state.userAuth.notifications.filter((notif) => {
          return notif.status === 0;
        }),
      user: (state) => state.authfack.user,
      userPicture: (state) => {
        if (state.user.user != null) {
          return state.user.user.picture_small;
        }
      },
    }),
    picture: () => {
      return JSON.parse(localStorage.getItem("user")).picture_small;
    },
    name: () => {
      return JSON.parse(localStorage.getItem("user")).name;
    },
  },
  methods: {
    ...mapActions(["userNotifications", "getNotifById", "sendNotif", "updateNotification"]),
    
    logout() {
      localStorage.removeItem('user');
      window.location = "/login";
    },

    redirect(notificationId) {
      this.getNotifById(notificationId);
      this.updateNotification(notificationId);
      this.userNotifications();
      this.$router.push({ path: `/notifications/show/${notificationId}` });
    },

    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    loadImage(picture) {
      return process.env.VUE_APP_IMAGE_URL + picture;
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      localStorage.setItem('dinflow-lang', locale);
      this.lan = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
  },
  created() {
    // let user = JSON.parse(localStorage.getItem('user'));
    // userApi.getPicture(user.id).then(response => {
    //   const myBlob = response.data;
    //   this.image = URL.createObjectURL(myBlob);
    // })
    // this.userNotifications();
  },
};
</script>
